/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  getOverrideProps,
  getOverridesFromVariants,
  mergeVariantsAndOverrides,
} from "@aws-amplify/ui-react/internal";
import { Icon } from "@aws-amplify/ui-react";
export default function Myicons(props) {
  const { overrides: overridesProp, ...rest } = props;
  const variants = [
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M13 6.5C13 7.93437 12.5344 9.25937 11.75 10.3344L15.7063 14.2937C16.0969 14.6844 16.0969 15.3187 15.7063 15.7094C15.3156 16.1 14.6813 16.1 14.2906 15.7094L10.3344 11.75C9.25938 12.5375 7.93438 13 6.5 13C2.90938 13 0 10.0906 0 6.5C0 2.90937 2.90938 0 6.5 0C10.0906 0 13 2.90937 13 6.5ZM6.5 11C8.98438 11 11 8.98437 11 6.5C11 4.01562 8.98438 2 6.5 2C4.01563 2 2 4.01562 2 6.5C2 8.98437 4.01563 11 6.5 11Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0%, 0%)" },
            },
          ],
        },
      },
      variantValues: { type: "search" },
    },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M13 6.5C13 7.93437 12.5344 9.25937 11.75 10.3344L15.7063 14.2937C16.0969 14.6844 16.0969 15.3187 15.7063 15.7094C15.3156 16.1 14.6813 16.1 14.2906 15.7094L10.3344 11.75C9.25938 12.5375 7.93438 13 6.5 13C2.90938 13 0 10.0906 0 6.5C0 2.90937 2.90938 0 6.5 0C10.0906 0 13 2.90937 13 6.5ZM6.5 11C8.98438 11 11 8.98437 11 6.5C11 4.01562 8.98438 2 6.5 2C4.01563 2 2 4.01562 2 6.5C2 8.98437 4.01563 11 6.5 11Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0%, 0%)" },
            },
          ],
        },
      },
      variantValues: { type: "search/white" },
    },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M12.7324 3C12.3866 3.5978 11.7403 4 11 4C9.89543 4 9 3.10457 9 2C9 0.895431 9.89543 0 11 0C11.7403 0 12.3866 0.402199 12.7324 1L15 1C15.5523 1 16 1.44772 16 2C16 2.55228 15.5523 3 15 3L12.7324 3Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0px, 0px)" },
            },
            {
              d: "M0 2C0 1.44772 0.447715 1 1 1L7 1L7 3L1 3C0.447715 3 0 2.55228 0 2Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0px, 0px)" },
            },
            {
              d: "M12.7324 15C12.3866 15.5978 11.7403 16 11 16C9.89543 16 9 15.1046 9 14C9 12.8954 9.89543 12 11 12C11.7403 12 12.3866 12.4022 12.7324 13L15 13C15.5523 13 16 13.4477 16 14C16 14.5523 15.5523 15 15 15L12.7324 15Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0px, 0px)" },
            },
            {
              d: "M0 14C0 13.4477 0.447715 13 1 13L7 13L7 15L1 15C0.447715 15 0 14.5523 0 14Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0px, 0px)" },
            },
            {
              d: "M7 8C7 9.10457 6.10457 10 5 10C4.25972 10 3.61337 9.5978 3.26756 9L1 9C0.447715 9 0 8.55228 0 8C0 7.44772 0.447715 7 1 7L3.26756 7C3.61337 6.4022 4.25972 6 5 6C6.10457 6 7 6.89543 7 8Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0px, 0px)" },
            },
            {
              d: "M15 7L9 7L9 9L15 9C15.5523 9 16 8.55228 16 8C16 7.44772 15.5523 7 15 7Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0px, 0px)" },
            },
          ],
        },
      },
      variantValues: { type: "filter" },
    },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M7.66525 6.17636C8.11158 6.63191 8.11158 7.37173 7.66525 7.82728L1.95224 13.6583C1.50591 14.1139 0.781076 14.1139 0.334747 13.6583C-0.111582 13.2028 -0.111582 12.463 0.334747 12.0074L5.24079 7L0.338317 1.99258C-0.108012 1.53703 -0.108012 0.797215 0.338317 0.341663C0.784646 -0.113888 1.50948 -0.113888 1.95581 0.341663L7.66882 6.17272L7.66525 6.17636Z",
              fill: "rgba(170,170,170,1)",
              fillRule: "nonzero",
              style: { transform: "translate(25%, 6.25%)" },
            },
          ],
        },
      },
      variantValues: { type: "angle-right" },
    },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M0.334746 7.82364C-0.111582 7.36809 -0.111582 6.62827 0.334746 6.17272L6.04776 0.341663C6.49409 -0.113888 7.21892 -0.113888 7.66525 0.341663C8.11158 0.797215 8.11158 1.53703 7.66525 1.99258L2.75921 7L7.66168 12.0074C8.10801 12.463 8.10801 13.2028 7.66168 13.6583C7.21535 14.1139 6.49052 14.1139 6.04419 13.6583L0.331175 7.82728L0.334746 7.82364Z",
              fill: "rgba(170,170,170,1)",
              fillRule: "nonzero",
              style: { transform: "translate(25%, 6.25%)" },
            },
          ],
        },
      },
      variantValues: { type: "angle-left" },
    },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M7.56429 10.9929C7.175 11.3821 6.53929 11.3821 6.15 10.9929L3.86429 8.70714C3.47393 8.31786 3.47393 7.68214 3.86429 7.29286C4.25357 6.90357 4.88929 6.90357 5.27857 7.29286L6.85714 8.87143L10.7214 5.00714C11.1107 4.61786 11.7464 4.61786 12.1357 5.00714C12.525 5.39643 12.525 6.03214 12.1357 6.42143L7.56429 10.9929ZM0 2.28571C0 1.02321 1.02321 0 2.28571 0L13.7143 0C14.975 0 16 1.02321 16 2.28571L16 13.7143C16 14.975 14.975 16 13.7143 16L2.28571 16C1.02321 16 0 14.975 0 13.7143L0 2.28571ZM1.71429 2.28571L1.71429 13.7143C1.71429 14.0286 1.97 14.2857 2.28571 14.2857L13.7143 14.2857C14.0286 14.2857 14.2857 14.0286 14.2857 13.7143L14.2857 2.28571C14.2857 1.97 14.0286 1.71429 13.7143 1.71429L2.28571 1.71429C1.97 1.71429 1.71429 1.97 1.71429 2.28571Z",
              fill: "rgba(170,170,170,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0%, 0%)" },
            },
          ],
        },
      },
      variantValues: { type: "squareCheck" },
    },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M7.56429 10.9929C7.175 11.3821 6.53929 11.3821 6.15 10.9929L3.86429 8.70714C3.47393 8.31786 3.47393 7.68214 3.86429 7.29286C4.25357 6.90357 4.88929 6.90357 5.27857 7.29286L6.85714 8.87143L10.7214 5.00714C11.1107 4.61786 11.7464 4.61786 12.1357 5.00714C12.525 5.39643 12.525 6.03214 12.1357 6.42143L7.56429 10.9929ZM0 2.28571C0 1.02321 1.02321 0 2.28571 0L13.7143 0C14.975 0 16 1.02321 16 2.28571L16 13.7143C16 14.975 14.975 16 13.7143 16L2.28571 16C1.02321 16 0 14.975 0 13.7143L0 2.28571ZM1.71429 2.28571L1.71429 13.7143C1.71429 14.0286 1.97 14.2857 2.28571 14.2857L13.7143 14.2857C14.0286 14.2857 14.2857 14.0286 14.2857 13.7143L14.2857 2.28571C14.2857 1.97 14.0286 1.71429 13.7143 1.71429L2.28571 1.71429C1.97 1.71429 1.71429 1.97 1.71429 2.28571Z",
              fill: "rgba(0,153,255,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0%, 0%)" },
            },
          ],
        },
      },
      variantValues: { type: "squareCheck_b" },
    },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M13.7143 0C14.975 0 16 1.02321 16 2.28571L16 13.7143C16 14.975 14.975 16 13.7143 16L2.28571 16C1.02321 16 0 14.975 0 13.7143L0 2.28571C0 1.02321 1.02321 0 2.28571 0L13.7143 0ZM13.7143 1.71429L2.28571 1.71429C1.97 1.71429 1.71429 1.97 1.71429 2.28571L1.71429 13.7143C1.71429 14.0286 1.97 14.2857 2.28571 14.2857L13.7143 14.2857C14.0286 14.2857 14.2857 14.0286 14.2857 13.7143L14.2857 2.28571C14.2857 1.97 14.0286 1.71429 13.7143 1.71429Z",
              fill: "rgba(170,170,170,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0%, 0%)" },
            },
          ],
        },
      },
      variantValues: { type: "square" },
    },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M0 2C0 0.896875 0.896875 0 2 0L7 0L7 4C7 4.55312 7.44688 5 8 5L12 5L12 14C12 15.1031 11.1031 16 10 16L2 16C0.896875 16 0 15.1031 0 14L0 2ZM12 4L8 4L8 0L12 4Z",
              fill: "rgba(170,170,170,1)",
              fillRule: "nonzero",
              style: { transform: "translate(12.5%, 0%)" },
            },
          ],
        },
      },
      variantValues: { type: "file" },
    },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M2 14L14 14C15.1031 14 16 13.1031 16 12L16 4C16 2.89687 15.1031 2 14 2L9.32812 2C8.79688 2 8.2875 1.79063 7.9125 1.41563L7.08437 0.584375C6.70937 0.209375 6.2 0 5.66875 0L2 0C0.896875 0 0 0.896875 0 2L0 12C0 13.1031 0.896875 14 2 14Z",
              fill: "rgba(170,170,170,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0%, 6.25%)" },
            },
          ],
        },
      },
      variantValues: { type: "folder" },
    },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M5.5 1C5.5 0.447715 5.94772 0 6.5 0L9.5 0C10.0523 0 10.5 0.447715 10.5 1L10.5 5.25L12.4688 5.25C13.366 5.25 13.8093 6.34016 13.1666 6.96626L8.69784 11.3201C8.30953 11.6984 7.69047 11.6984 7.30217 11.3201L2.83337 6.96626C2.19074 6.34016 2.634 5.25 3.5312 5.25L5.5 5.25L5.5 1Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0%, 0%)" },
            },
            {
              d: "M1 14C0.447715 14 0 14.4477 0 15C0 15.5523 0.447715 16 1 16L15 16C15.5523 16 16 15.5523 16 15C16 14.4477 15.5523 14 15 14L1 14Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0%, 0%)" },
            },
          ],
        },
      },
      variantValues: { type: "download" },
    },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M4.225 0.553125C4.39375 0.2125 4.74062 0 5.11875 0L8.88125 0C9.25937 0 9.60625 0.2125 9.775 0.553125L10 1L13 1C13.5531 1 14 1.44687 14 2C14 2.55312 13.5531 3 13 3L1 3C0.446875 3 0 2.55312 0 2C0 1.44687 0.446875 1 1 1L4 1L4.225 0.553125ZM1 4L13 4L13 14C13 15.1031 12.1031 16 11 16L3 16C1.89687 16 1 15.1031 1 14L1 4ZM4 6C3.725 6 3.5 6.225 3.5 6.5L3.5 13.5C3.5 13.775 3.725 14 4 14C4.275 14 4.5 13.775 4.5 13.5L4.5 6.5C4.5 6.225 4.275 6 4 6ZM7 6C6.725 6 6.5 6.225 6.5 6.5L6.5 13.5C6.5 13.775 6.725 14 7 14C7.275 14 7.5 13.775 7.5 13.5L7.5 6.5C7.5 6.225 7.275 6 7 6ZM10 6C9.725 6 9.5 6.225 9.5 6.5L9.5 13.5C9.5 13.775 9.725 14 10 14C10.275 14 10.5 13.775 10.5 13.5L10.5 6.5C10.5 6.225 10.275 6 10 6Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(6.25%, 0%)" },
            },
          ],
        },
      },
      variantValues: { type: "trash" },
    },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M7.99885 0C8.4426 0 8.85197 0.234375 9.07697 0.61875L15.827 12.1187C16.0551 12.5062 16.0551 12.9844 15.8332 13.3719C15.6113 13.7594 15.1957 14 14.7488 14L1.24885 14C0.801972 14 0.386347 13.7594 0.164472 13.3719C-0.0574034 12.9844 -0.0542784 12.5031 0.170722 12.1187L6.92072 0.61875C7.14572 0.234375 7.5551 0 7.99885 0ZM7.99885 4C7.58322 4 7.24885 4.33437 7.24885 4.75L7.24885 8.25C7.24885 8.66562 7.58322 9 7.99885 9C8.41447 9 8.74885 8.66562 8.74885 8.25L8.74885 4.75C8.74885 4.33437 8.41447 4 7.99885 4ZM8.99885 11C8.99885 10.4469 8.55197 10 7.99885 10C7.44572 10 6.99885 10.4469 6.99885 11C6.99885 11.5531 7.44572 12 7.99885 12C8.55197 12 8.99885 11.5531 8.99885 11Z",
              fill: "rgba(255,76,108,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0.01%, 6.25%)" },
            },
          ],
        },
      },
      variantValues: { type: "attention" },
    },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M6.9994 0C6.44628 0 5.9994 0.446875 5.9994 1L5.9994 1.6C3.71815 2.0625 1.9994 4.08125 1.9994 6.5L1.9994 7.0875C1.9994 8.55625 1.45878 9.975 0.483777 11.075L0.252527 11.3344C-0.00997317 11.6281 -0.0724732 12.05 0.0869018 12.4094C0.246277 12.7688 0.605652 13 0.999402 13L12.9994 13C13.3932 13 13.7494 12.7688 13.9119 12.4094C14.0744 12.05 14.0088 11.6281 13.7463 11.3344L13.515 11.075C12.54 9.975 11.9994 8.55937 11.9994 7.0875L11.9994 6.5C11.9994 4.08125 10.2807 2.0625 7.9994 1.6L7.9994 1C7.9994 0.446875 7.55253 0 6.9994 0ZM8.41503 15.4156C8.79003 15.0406 8.9994 14.5312 8.9994 14L6.9994 14L4.9994 14C4.9994 14.5312 5.20878 15.0406 5.58378 15.4156C5.95878 15.7906 6.46815 16 6.9994 16C7.53065 16 8.04003 15.7906 8.41503 15.4156Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(6.25%, 0%)" },
            },
          ],
        },
      },
      variantValues: { type: "bell" },
    },
    { overrides: { Myicons: {} }, variantValues: { type: "user" } },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M7.82364 7.66525C7.36809 8.11158 6.62827 8.11158 6.17272 7.66525L0.341663 1.95224C-0.113888 1.50591 -0.113888 0.781076 0.341663 0.334747C0.797215 -0.111582 1.53703 -0.111582 1.99258 0.334747L7 5.2408L12.0074 0.338318C12.463 -0.108011 13.2028 -0.108011 13.6583 0.338318C14.1139 0.784647 14.1139 1.50949 13.6583 1.95581L7.82728 7.66883L7.82364 7.66525Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(6.25%, 31.25%)" },
            },
          ],
        },
      },
      variantValues: { type: "angle-down" },
    },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M8 0C3.58125 0 0 3.58125 0 8C0 12.4187 3.58125 16 8 16C12.4187 16 16 12.4187 16 8C16 3.58125 12.4187 0 8 0ZM8 14.5C4.41563 14.5 1.5 11.5841 1.5 8C1.5 4.41594 4.41563 1.5 8 1.5C11.5844 1.5 14.5 4.41594 14.5 8C14.5 11.5841 11.5844 14.5 8 14.5ZM8 10.5C7.4375 10.5 7 10.9375 7 11.5C7 12.0625 7.40938 12.5 8 12.5C8.53438 12.5 9 12.0625 9 11.5C9 10.9375 8.53438 10.5 8 10.5ZM9.03438 4L7.4375 4C6.21875 4 5.25 4.96875 5.25 6.1875C5.25 6.59375 5.59375 6.9375 6 6.9375C6.40625 6.9375 6.75 6.59375 6.75 6.1875C6.75 5.8125 7.03438 5.5 7.40938 5.5L9.00625 5.5C9.40938 5.5 9.75 5.8125 9.75 6.1875C9.75 6.4375 9.625 6.62813 9.40625 6.75313L7.625 7.84375C7.375 8 7.25 8.25 7.25 8.5L7.25 9C7.25 9.40625 7.59375 9.75 8 9.75C8.40625 9.75 8.75 9.40625 8.75 9L8.75 8.9375L10.1594 8.0625C10.8156 7.65625 11.2219 6.9375 11.2219 6.1875C11.25 4.96875 10.2812 4 9.03438 4Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0%, 0%)" },
            },
          ],
        },
      },
      variantValues: { type: "question" },
    },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M4 0C4.55312 0 5 0.446875 5 1L5 2L9 2L9 1C9 0.446875 9.44687 0 10 0C10.5531 0 11 0.446875 11 1L11 2L12.5 2C13.3281 2 14 2.67188 14 3.5L14 5L0 5L0 3.5C0 2.67188 0.671875 2 1.5 2L3 2L3 1C3 0.446875 3.44688 0 4 0ZM0 6L14 6L14 14.5C14 15.3281 13.3281 16 12.5 16L1.5 16C0.671875 16 0 15.3281 0 14.5L0 6ZM2 8.5L2 9.5C2 9.775 2.225 10 2.5 10L3.5 10C3.775 10 4 9.775 4 9.5L4 8.5C4 8.225 3.775 8 3.5 8L2.5 8C2.225 8 2 8.225 2 8.5ZM6 8.5L6 9.5C6 9.775 6.225 10 6.5 10L7.5 10C7.775 10 8 9.775 8 9.5L8 8.5C8 8.225 7.775 8 7.5 8L6.5 8C6.225 8 6 8.225 6 8.5ZM10.5 8C10.225 8 10 8.225 10 8.5L10 9.5C10 9.775 10.225 10 10.5 10L11.5 10C11.775 10 12 9.775 12 9.5L12 8.5C12 8.225 11.775 8 11.5 8L10.5 8ZM2 12.5L2 13.5C2 13.775 2.225 14 2.5 14L3.5 14C3.775 14 4 13.775 4 13.5L4 12.5C4 12.225 3.775 12 3.5 12L2.5 12C2.225 12 2 12.225 2 12.5ZM6.5 12C6.225 12 6 12.225 6 12.5L6 13.5C6 13.775 6.225 14 6.5 14L7.5 14C7.775 14 8 13.775 8 13.5L8 12.5C8 12.225 7.775 12 7.5 12L6.5 12ZM10 12.5L10 13.5C10 13.775 10.225 14 10.5 14L11.5 14C11.775 14 12 13.775 12 13.5L12 12.5C12 12.225 11.775 12 11.5 12L10.5 12C10.225 12 10 12.225 10 12.5Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(6.25%, 0%)" },
            },
          ],
        },
      },
      variantValues: { type: "calendar" },
    },
    {
      overrides: {
        Myicons: {
          paths: [
            {
              d: "M22.4376 7.80938C22.5868 8.21719 22.4609 8.67188 22.1392 8.9625L20.1204 10.8094C20.1717 11.1984 20.1996 11.5969 20.1996 12C20.1996 12.4031 20.1717 12.8016 20.1204 13.1906L22.1392 15.0375C22.4609 15.3281 22.5868 15.7828 22.4376 16.1906C22.2325 16.7484 21.9854 17.2828 21.701 17.7984L21.4818 18.1781C21.1741 18.6937 20.8291 19.1812 20.4514 19.6406C20.1763 19.9781 19.7194 20.0906 19.3091 19.9594L16.7121 19.1297C16.0873 19.6125 15.3973 20.0156 14.6606 20.3203L14.0778 22.9969C13.9845 23.4234 13.6582 23.7609 13.2292 23.8312C12.5858 23.9391 11.9237 23.9953 11.2477 23.9953C10.5716 23.9953 9.90954 23.9391 9.26611 23.8312C8.83716 23.7609 8.51079 23.4234 8.41754 22.9969L7.83473 20.3203C7.09806 20.0156 6.40801 19.6125 5.78324 19.1297L3.1909 19.9641C2.7806 20.0953 2.32368 19.9781 2.04859 19.6453C1.67093 19.1859 1.32591 18.6984 1.01818 18.1828L0.799045 17.8031C0.514633 17.2875 0.267522 16.7531 0.0623727 16.1953C-0.0868268 15.7875 0.0390603 15.3328 0.360772 15.0422L2.37963 13.1953C2.32834 12.8016 2.30036 12.4031 2.30036 12C2.30036 11.5969 2.32834 11.1984 2.37963 10.8094L0.360772 8.9625C0.0390603 8.67188 -0.0868268 8.21719 0.0623727 7.80938C0.267522 7.25156 0.514633 6.71719 0.799045 6.20156L1.01818 5.82187C1.32591 5.30625 1.67093 4.81875 2.04859 4.35938C2.32368 4.02187 2.7806 3.90937 3.1909 4.04062L5.7879 4.87031C6.41267 4.3875 7.10272 3.98438 7.83939 3.67969L8.4222 1.00312C8.51545 0.576562 8.84183 0.239062 9.27078 0.16875C9.9142 0.05625 10.5763 0 11.2523 0C11.9284 0 12.5905 0.05625 13.2339 0.164062C13.6628 0.234375 13.9892 0.571875 14.0825 0.998437L14.6653 3.675C15.4019 3.97969 16.092 4.38281 16.7168 4.86563L19.3138 4.03594C19.7241 3.90469 20.181 4.02187 20.4561 4.35469C20.8337 4.81406 21.1788 5.30156 21.4865 5.81719L21.7056 6.19687C21.99 6.7125 22.2371 7.24687 22.4423 7.80469L22.4376 7.80938ZM11.2523 15.75C13.3131 15.75 14.9823 14.0719 14.9823 12C14.9823 9.92813 13.3131 8.25 11.2523 8.25C9.19151 8.25 7.52235 9.92813 7.52235 12C7.52235 14.0719 9.19151 15.75 11.2523 15.75Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(3.13%, 0%)" },
            },
          ],
        },
      },
      variantValues: { type: "setting" },
    },
    {
      overrides: {
        Myicons: {
          paths: [
            {
              d: "M12 1.28493C12 0.778685 11.7027 0.320655 11.2406 0.111729C10.7786 -0.0931786 10.2362 -0.0128225 9.85851 0.324673L4.43849 5.14202L2.5714 5.14202C1.15311 5.14202 0 6.29513 0 7.71342L0 10.2848C0 11.7031 1.15311 12.8562 2.5714 12.8562L4.43849 12.8562L9.85851 17.6736C10.2362 18.011 10.7786 18.0954 11.2406 17.8865C11.7027 17.6776 12 17.2195 12 16.7133L12 1.28493Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(6.25%, 12.5%)" },
            },
            {
              d: "M18.2452 3.21179C19.9237 4.57947 21 6.66597 21 9.00113C21 11.3363 19.9237 13.4228 18.2452 14.7905C17.845 15.1169 17.2583 15.0547 16.9319 14.6545C16.6055 14.2543 16.6677 13.6676 17.0679 13.3412C18.3307 12.3154 19.135 10.7535 19.135 9.00113C19.135 7.24879 18.3307 5.68683 17.0679 4.65718C16.6677 4.3308 16.6094 3.74409 16.9319 3.34389C17.2544 2.94369 17.845 2.88541 18.2452 3.2079L18.2452 3.21179Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(6.25%, 12.5%)" },
            },
            {
              d: "M16.5228 6.10649C17.3582 6.79033 18 7.83051 18 9.00003C18 10.1696 17.3582 11.212 16.5228 11.8958C16.1226 12.2222 15.5359 12.16 15.2095 11.7598C14.8831 11.3596 14.9453 10.7729 15.3455 10.4466C15.7651 10.1046 16.135 9.58285 16.135 9.00003C16.135 8.41721 15.7651 7.89769 15.3455 7.55188C14.9453 7.22551 14.887 6.6388 15.2095 6.2386C15.532 5.83839 16.1226 5.78011 16.5228 6.10261L16.5228 6.10649Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(6.25%, 12.5%)" },
            },
          ],
        },
      },
      variantValues: { type: "alarmON" },
    },
    {
      overrides: {
        Myicons: {
          paths: [
            {
              d: "M12 1.28493C12 0.778685 11.7027 0.320655 11.2406 0.111729C10.7786 -0.0931786 10.2362 -0.0128225 9.85851 0.324673L4.43849 5.14202L2.5714 5.14202C1.15311 5.14202 0 6.29513 0 7.71342L0 10.2848C0 11.7031 1.15311 12.8562 2.5714 12.8562L4.43849 12.8562L9.85851 17.6736C10.2362 18.011 10.7786 18.0954 11.2406 17.8865C11.7027 17.6776 12 17.2195 12 16.7133L12 1.28493Z",
              fill: "rgba(217,217,217,1)",
              fillRule: "nonzero",
              style: { transform: "translate(6.25%, 12.5%)" },
            },
            {
              d: "M18.2452 3.21179C19.9237 4.57947 21 6.66597 21 9.00113C21 11.3363 19.9237 13.4228 18.2452 14.7905C17.845 15.1169 17.2583 15.0547 16.9319 14.6545C16.6055 14.2543 16.6677 13.6676 17.0679 13.3412C18.3307 12.3154 19.135 10.7535 19.135 9.00113C19.135 7.24879 18.3307 5.68683 17.0679 4.65718C16.6677 4.3308 16.6094 3.74409 16.9319 3.34389C17.2544 2.94369 17.845 2.88541 18.2452 3.2079L18.2452 3.21179Z",
              fill: "rgba(217,217,217,1)",
              fillRule: "nonzero",
              style: { transform: "translate(6.25%, 12.5%)" },
            },
            {
              d: "M16.5228 6.10649C17.3582 6.79033 18 7.83051 18 9.00003C18 10.1696 17.3582 11.212 16.5228 11.8958C16.1226 12.2222 15.5359 12.16 15.2095 11.7598C14.8831 11.3596 14.9453 10.7729 15.3455 10.4466C15.7651 10.1046 16.135 9.58285 16.135 9.00003C16.135 8.41721 15.7651 7.89769 15.3455 7.55188C14.9453 7.22551 14.887 6.6388 15.2095 6.2386C15.532 5.83839 16.1226 5.78011 16.5228 6.10261L16.5228 6.10649Z",
              fill: "rgba(217,217,217,1)",
              fillRule: "nonzero",
              style: { transform: "translate(6.25%, 12.5%)" },
            },
          ],
        },
      },
      variantValues: { type: "alarmMute" },
    },
    {
      overrides: {
        Myicons: {
          paths: [
            {
              d: "M1.62132 0.292893C1.2308 0.683418 1.2308 1.31658 1.62132 1.70711L18.5919 18.6777C18.9824 19.0682 19.6156 19.0682 20.0061 18.6777C20.3966 18.2871 20.3966 17.654 20.0061 17.2635L18.7085 15.9659C20.1192 14.6085 21 12.6995 21 10.5869C21 8.25178 19.9237 6.16529 18.2452 4.7976L18.2452 4.79372C17.845 4.47122 17.2544 4.5295 16.9319 4.92971C16.6094 5.32991 16.6677 5.91662 17.0679 6.24299C18.3307 7.27264 19.135 8.8346 19.135 10.5869C19.135 12.186 18.4652 13.6266 17.3885 14.6458L16.3407 13.5981C16.4044 13.5672 16.4655 13.5284 16.5228 13.4817C17.3582 12.7978 18 11.7554 18 10.5858C18 9.41632 17.3582 8.37615 16.5228 7.69231L16.5228 7.68842C16.1226 7.36593 15.532 7.42421 15.2095 7.82441C14.887 8.22462 14.9453 8.81132 15.3455 9.1377C15.7651 9.48351 16.135 10.003 16.135 10.5858C16.135 11.1687 15.7651 11.6905 15.3455 12.0324C15.2357 12.122 15.1513 12.2312 15.0934 12.3508L12 9.25735L12 2.87074C12 2.3645 11.7027 1.90647 11.2406 1.69754C10.7786 1.49264 10.2362 1.57299 9.85851 1.91049L7.1026 4.35996L3.03554 0.292893C2.64501 -0.097631 2.01185 -0.0976311 1.62132 0.292893Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(1.5px, 1.41px)" },
            },
            {
              d: "M2.5714 6.72784L3.81365 6.72784L12 14.9142L12 18.2991C12 18.8054 11.7027 19.2634 11.2406 19.4723C10.7786 19.6812 10.2362 19.5969 9.85851 19.2594L4.43849 14.442L2.5714 14.442C1.15311 14.442 0 13.2889 0 11.8706L0 9.29923C0 7.88095 1.15311 6.72784 2.5714 6.72784Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(1.5px, 1.41px)" },
            },
          ],
        },
      },
      variantValues: { type: "alarmOFF" },
    },
    {
      overrides: {
        Myicons: {
          paths: [
            {
              d: "M4.66666 0C3.56209 0 2.66666 0.895431 2.66666 2L2.66666 5.33333L13.3333 5.33333L13.3333 2C13.3333 0.895431 12.4379 0 11.3333 0L4.66666 0Z",
              fill: "rgba(255,76,108,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4px, 2px)" },
            },
            {
              d: "M13.3333 6.66663L2.66666 6.66663L2.66666 12L13.3333 12L13.3333 6.66663Z",
              fill: "rgba(255,76,108,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4px, 2px)" },
            },
            {
              d: "M2.66666 13.3334L13.3333 13.3334L13.3333 17.3333L15 17.3333C15.5523 17.3333 16 17.781 16 18.3333L16 20L0 20L0 18.3333C0 17.781 0.447715 17.3333 1 17.3333L2.66666 17.3333L2.66666 13.3334Z",
              fill: "rgba(255,76,108,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4px, 2px)" },
            },
          ],
        },
      },
      variantValues: { type: "patlightWarning" },
    },
    {
      overrides: {
        Myicons: {
          paths: [
            {
              d: "M4.66666 0C3.56209 0 2.66666 0.895431 2.66666 2L2.66666 5.33333L13.3333 5.33333L13.3333 2C13.3333 0.895431 12.4379 0 11.3333 0L4.66666 0Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4px, 2px)" },
            },
            {
              d: "M13.3333 6.66663L2.66666 6.66663L2.66666 12L13.3333 12L13.3333 6.66663Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4px, 2px)" },
            },
            {
              d: "M2.66666 13.3334L13.3333 13.3334L13.3333 17.3333L15 17.3333C15.5523 17.3333 16 17.781 16 18.3333L16 20L0 20L0 18.3333C0 17.781 0.447715 17.3333 1 17.3333L2.66666 17.3333L2.66666 13.3334Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4px, 2px)" },
            },
          ],
        },
      },
      variantValues: { type: "patlightOn" },
    },
    {
      overrides: {
        Myicons: {
          paths: [
            {
              d: "M4.66666 0C3.56209 0 2.66666 0.895431 2.66666 2L2.66666 5.33333L13.3333 5.33333L13.3333 2C13.3333 0.895431 12.4379 0 11.3333 0L4.66666 0Z",
              fill: "rgba(217,217,217,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4px, 2px)" },
            },
            {
              d: "M13.3333 6.66663L2.66666 6.66663L2.66666 12L13.3333 12L13.3333 6.66663Z",
              fill: "rgba(217,217,217,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4px, 2px)" },
            },
            {
              d: "M2.66666 13.3334L13.3333 13.3334L13.3333 17.3333L15 17.3333C15.5523 17.3333 16 17.781 16 18.3333L16 20L0 20L0 18.3333C0 17.781 0.447715 17.3333 1 17.3333L2.66666 17.3333L2.66666 13.3334Z",
              fill: "rgba(217,217,217,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4px, 2px)" },
            },
          ],
        },
      },
      variantValues: { type: "patlightMute" },
    },
    {
      overrides: {
        Myicons: {
          paths: [
            {
              d: "M7.13134 0.300607C7.59535 0.733262 7.63285 1.46732 7.2157 1.94859L3.84103 5.83762C3.6348 6.07583 3.3442 6.2168 3.03486 6.22166C2.72552 6.22653 2.43023 6.10499 2.20994 5.88137L0.330436 3.93686C-0.110145 3.47989 -0.110145 2.74098 0.330436 2.28888C0.771018 1.83678 1.48345 1.83191 1.91934 2.28888L2.95518 3.36322L5.53774 0.38811C5.95489 -0.0931577 6.66263 -0.132048 7.12665 0.300607L7.13134 0.300607ZM7.13134 8.07868C7.59535 8.51133 7.63285 9.24539 7.2157 9.72666L3.84103 13.6157C3.6348 13.8539 3.3442 13.9949 3.03486 13.9997C2.72552 14.0046 2.43023 13.8831 2.20994 13.6594L0.330436 11.7149C-0.110145 11.258 -0.110145 10.519 0.330436 10.0669C0.771018 9.61485 1.48345 9.60999 1.91934 10.0669L2.95518 11.1413L5.53774 8.16618C5.95489 7.68491 6.66263 7.64602 7.12665 8.07868L7.13134 8.07868ZM10.5013 3.11044C10.5013 2.24999 11.1716 1.55482 12.0012 1.55482L22.5001 1.55482C23.3298 1.55482 24 2.24999 24 3.11044C24 3.97088 23.3298 4.66605 22.5001 4.66605L12.0012 4.66605C11.1716 4.66605 10.5013 3.97088 10.5013 3.11044ZM10.5013 10.8885C10.5013 10.0281 11.1716 9.33289 12.0012 9.33289L22.5001 9.33289C23.3298 9.33289 24 10.0281 24 10.8885C24 11.749 23.3298 12.4441 22.5001 12.4441L12.0012 12.4441C11.1716 12.4441 10.5013 11.749 10.5013 10.8885ZM7.50161 18.6666C7.50161 17.8061 8.17186 17.111 9.00147 17.111L22.5001 17.111C23.3298 17.111 24 17.8061 24 18.6666C24 19.527 23.3298 20.2222 22.5001 20.2222L9.00147 20.2222C8.17186 20.2222 7.50161 19.527 7.50161 18.6666ZM2.25212 21C1.01006 21 0.00234351 19.9548 0.00234351 18.6666C0.00234351 17.3783 1.01006 16.3332 2.25212 16.3332C3.49419 16.3332 4.5019 17.3783 4.5019 18.6666C4.5019 19.9548 3.49419 21 2.25212 21Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0%, 6.25%)" },
            },
          ],
        },
      },
      variantValues: { type: "management" },
    },
    {
      overrides: {
        Myicons: {
          paths: [
            {
              d: "M0.292893 2.12129C-0.0976308 1.73077 -0.0976313 1.0976 0.292893 0.707078C0.683417 0.316554 1.31658 0.316554 1.70711 0.707078L2.84421 1.84418C2.92372 0.812434 3.7861 0 4.83823 0L11.5049 0C12.6095 0 13.5049 0.895431 13.5049 2L13.5049 5.33333L6.33336 5.33333L7.66665 6.66663L13.5049 6.66663L13.5049 12L13 12L18.6777 17.6776C19.0682 18.0682 19.0682 18.7013 18.6777 19.0919C18.2871 19.4824 17.654 19.4824 17.2635 19.0919L0.292893 2.12129Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(3.83px, 2px)" },
            },
            {
              d: "M2.83823 12L2.83823 7.49503L7.34316 12L2.83823 12Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(3.83px, 2px)" },
            },
            {
              d: "M2.83823 13.3334L8.67658 13.3334L15.3432 20L0.171571 20L0.171571 18.3333C0.171571 17.781 0.619286 17.3333 1.17157 17.3333L2.83823 17.3333L2.83823 13.3334Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(3.83px, 2px)" },
            },
          ],
        },
      },
      variantValues: { type: "patlightOFF" },
    },
    {
      overrides: {
        Myicons: {
          paths: [
            {
              d: "M23.9917 10.9785C23.9917 11.752 23.3667 12.3578 22.6583 12.3578L21.325 12.3578L21.3542 19.2414C21.3542 19.3574 21.3458 19.4734 21.3333 19.5895L21.3333 20.2812C21.3333 21.2309 20.5875 22 19.6667 22L19 22C18.9542 22 18.9083 22 18.8625 21.9957C18.8042 22 18.7458 22 18.6875 22L17.3333 22L16.3333 22C15.4125 22 14.6667 21.2309 14.6667 20.2812L14.6667 19.25L14.6667 16.5C14.6667 15.7395 14.0708 15.125 13.3333 15.125L10.6667 15.125C9.92917 15.125 9.33333 15.7395 9.33333 16.5L9.33333 19.25L9.33333 20.2812C9.33333 21.2309 8.5875 22 7.66667 22L6.66667 22L5.3375 22C5.275 22 5.2125 21.9957 5.15 21.9914C5.1 21.9957 5.05 22 5 22L4.33333 22C3.4125 22 2.66667 21.2309 2.66667 20.2812L2.66667 15.4688C2.66667 15.4301 2.66667 15.3871 2.67083 15.3484L2.67083 12.3578L1.33333 12.3578C0.583333 12.3578 0 11.7563 0 10.9785C0 10.5918 0.125 10.248 0.416667 9.94727L11.1 0.34375C11.3917 0.0429688 11.725 0 12.0167 0C12.3083 0 12.6417 0.0859375 12.8917 0.300781L23.5333 9.94727C23.8667 10.248 24.0333 10.5918 23.9917 10.9785Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0%, 4.17%)" },
            },
          ],
        },
      },
      variantValues: { type: "home" },
    },
    {
      overrides: {
        Myicons: {
          paths: [
            {
              d: "M0.585786 0.644524C-0.195263 1.42557 -0.195261 2.6919 0.585787 3.47295L7.11129 9.99846L0.585804 16.5239C-0.195244 17.305 -0.195245 18.5713 0.585804 19.3524L0.644542 19.4111C1.42559 20.1922 2.69192 20.1922 3.47297 19.4111L9.99846 12.8856L16.5239 19.4111C17.305 20.1921 18.5713 20.1921 19.3524 19.4111L19.4111 19.3524C20.1921 18.5713 20.1921 17.305 19.4111 16.5239L12.8856 9.99846L19.4111 3.47297C20.1922 2.69192 20.1922 1.42559 19.4111 0.644541L19.3524 0.585803C18.5713 -0.195246 17.305 -0.195244 16.5239 0.585804L9.99846 7.11129L3.47295 0.585787C2.6919 -0.195262 1.42557 -0.195262 0.644524 0.585786L0.585786 0.644524Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(2px, 2px)" },
            },
          ],
        },
      },
      variantValues: { type: "cross" },
    },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6Z",
              fill: "rgba(250,180,50,1)",
              fillRule: "nonzero",
              style: { transform: "translate(2px, 2px)" },
            },
          ],
        },
      },
      variantValues: { type: "CircleWarning" },
    },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6Z",
              fill: "rgba(38,193,147,1)",
              fillRule: "nonzero",
              style: { transform: "translate(2px, 2px)" },
            },
          ],
        },
      },
      variantValues: { type: "CircleDefault" },
    },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6Z",
              fill: "rgba(170,170,170,1)",
              fillRule: "nonzero",
              style: { transform: "translate(2px, 2px)" },
            },
          ],
        },
      },
      variantValues: { type: "CircleGray" },
    },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M5.99334 7.47066C5.47639 8.17645 4.52361 8.17645 4.00666 7.47066L0.302169 2.41294C-0.399655 1.45475 0.199225 -9.584e-08 1.29551 2.27374e-13L8.70449 6.47714e-07C9.80078 7.43554e-07 10.3997 1.45475 9.69783 2.41294L5.99334 7.47066Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(3px, 4px)" },
            },
          ],
        },
      },
      variantValues: { type: "TriangleDownDark" },
    },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6Z",
              fill: "rgba(255,76,79,1)",
              fillRule: "nonzero",
              style: { transform: "translate(2px, 2px)" },
            },
          ],
        },
      },
      variantValues: { type: "CircleError" },
    },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M8 16C12.4187 16 16 12.4187 16 8C16 3.58125 12.4187 0 8 0C3.58125 0 0 3.58125 0 8C0 12.4187 3.58125 16 8 16ZM11.5312 6.53125L7.53125 10.5312C7.2375 10.825 6.7625 10.825 6.47188 10.5312L4.47188 8.53125C4.17813 8.2375 4.17813 7.7625 4.47188 7.47188C4.76562 7.18125 5.24062 7.17813 5.53125 7.47188L7 8.94063L10.4688 5.46875C10.7625 5.175 11.2375 5.175 11.5281 5.46875C11.8187 5.7625 11.8219 6.2375 11.5281 6.52812L11.5312 6.53125Z",
              fill: "rgba(170,170,170,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0%, 0%)" },
            },
          ],
        },
      },
      variantValues: { type: "CircleCheck" },
    },
    {
      overrides: {
        Myicons: {
          paths: [
            {
              d: "M12 1.28493C12 0.778685 11.7027 0.320655 11.2406 0.111729C10.7786 -0.0931786 10.2362 -0.0128225 9.85851 0.324673L4.43849 5.14202L2.5714 5.14202C1.15311 5.14202 0 6.29513 0 7.71342L0 10.2848C0 11.7031 1.15311 12.8562 2.5714 12.8562L4.43849 12.8562L9.85851 17.6736C10.2362 18.011 10.7786 18.0954 11.2406 17.8865C11.7027 17.6776 12 17.2195 12 16.7133L12 1.28493Z",
              fill: "rgba(255,76,108,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4.17%, 12.5%)" },
            },
            {
              d: "M18.2452 3.21179C19.9237 4.57947 21 6.66597 21 9.00113C21 11.3363 19.9237 13.4228 18.2452 14.7905C17.845 15.1169 17.2583 15.0547 16.9319 14.6545C16.6055 14.2543 16.6677 13.6676 17.0679 13.3412C18.3307 12.3154 19.135 10.7535 19.135 9.00113C19.135 7.24879 18.3307 5.68683 17.0679 4.65718C16.6677 4.3308 16.6094 3.74409 16.9319 3.34389C17.2544 2.94369 17.845 2.88541 18.2452 3.2079L18.2452 3.21179Z",
              fill: "rgba(255,76,108,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4.17%, 12.5%)" },
            },
            {
              d: "M16.5228 6.10649C17.3582 6.79033 18 7.83051 18 9.00003C18 10.1696 17.3582 11.212 16.5228 11.8958C16.1226 12.2222 15.5359 12.16 15.2095 11.7598C14.8831 11.3596 14.9453 10.7729 15.3455 10.4466C15.7651 10.1046 16.135 9.58285 16.135 9.00003C16.135 8.41721 15.7651 7.89769 15.3455 7.55189C14.9453 7.22551 14.887 6.6388 15.2095 6.2386C15.532 5.83839 16.1226 5.78011 16.5228 6.10261L16.5228 6.10649Z",
              fill: "rgba(255,76,108,1)",
              fillRule: "nonzero",
              style: { transform: "translate(4.17%, 12.5%)" },
            },
          ],
        },
      },
      variantValues: { type: "alarmWarningNew" },
    },
    {
      overrides: {
        Myicons: {
          width: "16px",
          height: "16px",
          viewBox: { minX: 0, minY: 0, width: 16, height: 16 },
          paths: [
            {
              d: "M7.01269 0L0.987305 0C0.185672 0 -0.280624 0.878444 0.185316 1.51085L3.19801 5.59988C3.59108 6.13337 4.40892 6.13337 4.80199 5.59988L7.81468 1.51085C8.28062 0.878444 7.81433 0 7.01269 0Z",
              fill: "rgba(170,170,170,1)",
              fillRule: "nonzero",
              style: { transform: "translate(25%, 31.25%)" },
            },
          ],
        },
      },
      variantValues: { type: "TriangleDownNew" },
    },
    {
      overrides: {
        Myicons: {
          paths: [
            {
              d: "M0.502232 8.60279C-0.167411 9.23731 -0.167411 10.2678 0.502232 10.9023L9.07366 19.0241C9.7433 19.6586 10.8308 19.6586 11.5004 19.0241C12.1701 18.3896 12.1701 17.3591 11.5004 16.7246L5.84866 11.3744L22.2844 11.3744C23.2326 11.3744 23.9987 10.6485 23.9987 9.75C23.9987 8.85152 23.2326 8.12564 22.2844 8.12564L5.85402 8.12564L11.4951 2.77538C12.1647 2.14087 12.1647 1.11041 11.4951 0.475888C10.8254 -0.158629 9.73795 -0.158629 9.0683 0.475888L0.496875 8.59772L0.502232 8.60279Z",
              fill: "rgba(100,100,100,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0%, 12.5%)" },
            },
          ],
        },
      },
      variantValues: { type: "ArrowLeft" },
    },
    {
      overrides: {
        Myicons: {
          width: "26px",
          height: "22px",
          viewBox: { minX: 0, minY: 0, width: 26, height: 22 },
          paths: [
            {
              d: "M7.00106 0.38C7.00106 0.38 6.98106 0.37 6.97106 0.36C6.84106 0.25 6.70106 0.17 6.55106 0.11C6.53106 0.11 6.51106 0.1 6.50106 0.09C6.35106 0.04 6.18106 0 6.01106 0C5.84106 0 5.68106 0.03 5.52106 0.09C5.50106 0.09 5.48106 0.09 5.47106 0.11C5.31106 0.17 5.17106 0.26 5.05106 0.36C5.04106 0.36 5.03106 0.37 5.02106 0.38L0.501064 4.38C-0.118936 4.93 -0.168936 5.88 0.381064 6.5C0.931064 7.12 1.88106 7.17 2.50106 6.62L4.50106 4.84L4.50106 20.5C4.50106 21.33 5.17106 22 6.00106 22C6.83106 22 7.50106 21.33 7.50106 20.5L7.50106 4.84L9.50106 6.62C9.79106 6.87 10.1411 7 10.5011 7C10.9111 7 11.3311 6.83 11.6211 6.5C12.1711 5.88 12.1111 4.93 11.5011 4.38L7.00106 0.38Z",
              fill: "rgba(170,170,170,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0%, 0%)" },
            },
            {
              d: "M1.5 3L4.5 3C5.33 3 6 2.33 6 1.5C6 0.67 5.33 0 4.5 0L1.5 0C0.67 0 0 0.67 0 1.5C0 2.33 0.67 3 1.5 3Z",
              fill: "rgba(170,170,170,1)",
              fillRule: "nonzero",
              style: { transform: "translate(53.85%, 11.36%)" },
            },
            {
              d: "M1.5 3L7.5 3C8.33 3 9 2.33 9 1.5C9 0.67 8.33 0 7.5 0L1.5 0C0.67 0 0 0.67 0 1.5C0 2.33 0.67 3 1.5 3Z",
              fill: "rgba(170,170,170,1)",
              fillRule: "nonzero",
              style: { transform: "translate(53.85%, 43.18%)" },
            },
            {
              d: "M10.5 0L1.5 0C0.67 0 0 0.67 0 1.5C0 2.33 0.67 3 1.5 3L10.5 3C11.33 3 12 2.33 12 1.5C12 0.67 11.33 0 10.5 0Z",
              fill: "rgba(170,170,170,1)",
              fillRule: "nonzero",
              style: { transform: "translate(53.85%, 75%)" },
            },
          ],
        },
      },
      variantValues: { type: "SortUp" },
    },
    {
      overrides: {
        Myicons: {
          width: "26px",
          height: "22px",
          viewBox: { minX: 0, minY: 0, width: 26, height: 22 },
          paths: [
            {
              d: "M9.49761 15.38L7.49761 17.16L7.49761 1.5C7.49761 0.67 6.82761 0 5.99761 0C5.16761 0 4.49761 0.67 4.49761 1.5L4.49761 17.16L2.49762 15.38C1.87762 14.83 0.927615 14.88 0.377615 15.5C-0.172385 16.12 -0.112385 17.07 0.497615 17.62L4.99761 21.62C4.99761 21.62 5.01761 21.63 5.02762 21.64C5.15762 21.75 5.29761 21.83 5.44761 21.89C5.46761 21.89 5.48761 21.9 5.49761 21.91C5.64761 21.96 5.81761 22 5.98761 22C6.15761 22 6.31762 21.97 6.47761 21.91C6.49761 21.91 6.51761 21.91 6.52762 21.89C6.68761 21.83 6.82761 21.74 6.94761 21.64C6.95761 21.64 6.96761 21.63 6.97761 21.62L11.4776 17.62C12.0976 17.07 12.1476 16.12 11.5976 15.5C11.0476 14.88 10.0976 14.82 9.47761 15.38L9.49761 15.38Z",
              fill: "rgba(170,170,170,1)",
              fillRule: "nonzero",
              style: { transform: "translate(0.01%, 0%)" },
            },
            {
              d: "M1.5 3L4.5 3C5.33 3 6 2.33 6 1.5C6 0.67 5.33 0 4.5 0L1.5 0C0.67 0 0 0.67 0 1.5C0 2.33 0.67 3 1.5 3Z",
              fill: "rgba(170,170,170,1)",
              fillRule: "nonzero",
              style: { transform: "translate(53.85%, 11.36%)" },
            },
            {
              d: "M1.5 3L7.5 3C8.33 3 9 2.33 9 1.5C9 0.67 8.33 0 7.5 0L1.5 0C0.67 0 0 0.67 0 1.5C0 2.33 0.67 3 1.5 3Z",
              fill: "rgba(170,170,170,1)",
              fillRule: "nonzero",
              style: { transform: "translate(53.85%, 43.18%)" },
            },
            {
              d: "M10.5 0L1.5 0C0.67 0 0 0.67 0 1.5C0 2.33 0.67 3 1.5 3L10.5 3C11.33 3 12 2.33 12 1.5C12 0.67 11.33 0 10.5 0Z",
              fill: "rgba(170,170,170,1)",
              fillRule: "nonzero",
              style: { transform: "translate(53.85%, 75%)" },
            },
          ],
        },
      },
      variantValues: { type: "SortDown" },
    },
  ];
  const overrides = mergeVariantsAndOverrides(
    getOverridesFromVariants(variants, props),
    overridesProp || {}
  );
  return (
    <Icon
      width="24px"
      height="24px"
      display="block"
      gap="unset"
      alignItems="unset"
      justifyContent="unset"
      overflow="hidden"
      position="relative"
      padding="0px 0px 0px 0px"
      viewBox={{ minX: 0, minY: 0, width: 24, height: 24 }}
      paths={[
        {
          d: "M9 10C11.8406 10 14.1429 7.76172 14.1429 5C14.1429 2.23828 11.8406 0 9 0C6.15938 0 3.85714 2.23828 3.85714 5C3.85714 7.76172 6.15938 10 9 10ZM7.16384 11.875C3.20625 11.875 0 14.9922 0 18.8398C0 19.4805 0.534375 20 1.1933 20L16.8067 20C17.4656 20 18 19.4805 18 18.8398C18 14.9922 14.7938 11.875 10.8362 11.875L7.16384 11.875Z",
          fill: "rgba(100,100,100,1)",
          fillRule: "nonzero",
          style: { transform: "translate(12.5%, 8.33%)" },
        },
      ]}
      {...rest}
      {...getOverrideProps(overrides, "Myicons")}
    ></Icon>
  );
}
